"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.routes = void 0;
const types_1 = require("./types");
exports.routes = (0, types_1.buildRoutes)({
    settings: {
        path: "/settings",
    },
    records: {
        path: "/settings/account/records",
    },
    submissionsBuilderV2: {
        path: "/settings/account/records/submissions-builder-v2/:submissionTypeId?",
    },
    propertyData: {
        path: "/settings/account/property-data",
    },
    editSection: {
        path: "/settings/account/property-data/section/:sectionId",
    },
    usersSettings: {
        path: "/settings/users",
    },
    teamSettings: {
        path: "/settings/users/team",
    },
    publicUsersSettings: {
        path: "/settings/users/public",
    },
});
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic2V0dGluZ3MuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9yb3V0aW5nL3NldHRpbmdzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFBLG1DQUFzQztBQUV6QixRQUFBLE1BQU0sR0FBRyxJQUFBLG1CQUFXLEVBQUM7SUFDaEMsUUFBUSxFQUFFO1FBQ1IsSUFBSSxFQUFFLFdBQVc7S0FDbEI7SUFDRCxPQUFPLEVBQUU7UUFDUCxJQUFJLEVBQUUsMkJBQTJCO0tBQ2xDO0lBQ0Qsb0JBQW9CLEVBQUU7UUFDcEIsSUFBSSxFQUFFLHFFQUFxRTtLQUM1RTtJQUNELFlBQVksRUFBRTtRQUNaLElBQUksRUFBRSxpQ0FBaUM7S0FDeEM7SUFDRCxXQUFXLEVBQUU7UUFDWCxJQUFJLEVBQUUsb0RBQW9EO0tBQzNEO0lBQ0QsYUFBYSxFQUFFO1FBQ2IsSUFBSSxFQUFFLGlCQUFpQjtLQUN4QjtJQUNELFlBQVksRUFBRTtRQUNaLElBQUksRUFBRSxzQkFBc0I7S0FDN0I7SUFDRCxtQkFBbUIsRUFBRTtRQUNuQixJQUFJLEVBQUUsd0JBQXdCO0tBQy9CO0NBQ0YsQ0FBQyxDQUFDIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgYnVpbGRSb3V0ZXMgfSBmcm9tIFwiLi90eXBlc1wiO1xuXG5leHBvcnQgY29uc3Qgcm91dGVzID0gYnVpbGRSb3V0ZXMoe1xuICBzZXR0aW5nczoge1xuICAgIHBhdGg6IFwiL3NldHRpbmdzXCIsXG4gIH0sXG4gIHJlY29yZHM6IHtcbiAgICBwYXRoOiBcIi9zZXR0aW5ncy9hY2NvdW50L3JlY29yZHNcIixcbiAgfSxcbiAgc3VibWlzc2lvbnNCdWlsZGVyVjI6IHtcbiAgICBwYXRoOiBcIi9zZXR0aW5ncy9hY2NvdW50L3JlY29yZHMvc3VibWlzc2lvbnMtYnVpbGRlci12Mi86c3VibWlzc2lvblR5cGVJZD9cIixcbiAgfSxcbiAgcHJvcGVydHlEYXRhOiB7XG4gICAgcGF0aDogXCIvc2V0dGluZ3MvYWNjb3VudC9wcm9wZXJ0eS1kYXRhXCIsXG4gIH0sXG4gIGVkaXRTZWN0aW9uOiB7XG4gICAgcGF0aDogXCIvc2V0dGluZ3MvYWNjb3VudC9wcm9wZXJ0eS1kYXRhL3NlY3Rpb24vOnNlY3Rpb25JZFwiLFxuICB9LFxuICB1c2Vyc1NldHRpbmdzOiB7XG4gICAgcGF0aDogXCIvc2V0dGluZ3MvdXNlcnNcIixcbiAgfSxcbiAgdGVhbVNldHRpbmdzOiB7XG4gICAgcGF0aDogXCIvc2V0dGluZ3MvdXNlcnMvdGVhbVwiLFxuICB9LFxuICBwdWJsaWNVc2Vyc1NldHRpbmdzOiB7XG4gICAgcGF0aDogXCIvc2V0dGluZ3MvdXNlcnMvcHVibGljXCIsXG4gIH0sXG59KTtcbiJdfQ==